import { Link, Route, Routes } from 'react-router-dom';
import RequireAuth from './auth/RequireAuth.jsx';
import AppShell from './components/AppShell.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Sites from './pages/Sites.jsx';
import SiteDetail from './pages/SiteDetail.jsx';
import Config from './pages/Config.jsx';
import Audit from './pages/Audit.jsx';
import { EmptyState } from './components/StateViews.jsx';
import { PinsProvider } from './pins/PinsContext.jsx';
import RequireAdmin from './auth/RequireAdmin.jsx';
import Users from './pages/Users.jsx';
import RequirePassword from './auth/RequirePassword.jsx';
import PasswordChange from './pages/PasswordChange.jsx';

function NotFound() {
  return (
    <div className="page">
      <EmptyState
        title="No such screen"
        body="That path isn't part of the control panel."
        action={
          <Link className="btn" to="/">
            Back to the dashboard
          </Link>
        }
      />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/change-password" element={<RequireAuth><PasswordChange forced /></RequireAuth>} />
      <Route
        element={
          <RequireAuth>
            <RequirePassword>
              <PinsProvider>
                <AppShell />
              </PinsProvider>
            </RequirePassword>
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/sites/:name" element={<SiteDetail />} />
        <Route path="/config" element={<Config />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/users" element={<RequireAdmin><Users /></RequireAdmin>} />
        <Route path="/account" element={<PasswordChange />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
